<template>
  <DashboardTemplate :navMenu="true">
    <div v-loading="loading">
      <div class="text-left pd-b-3">
        <h2 class="mg-less">เพิ่มหลักสูตร</h2>
      </div>
      <ManageCourseForm @createCourse="createCourse" />
    </div>
    <el-dialog
      title="กำลังอัปโหลดข้อมูล..."
      :visible.sync="dialogProgress"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="25vh"
      :width="widthMax < 767.98 ? '80%' : null"
      class="text-center padding-top-10"
    >
      <el-progress
        type="circle"
        :percentage="progress"
        :width="widthMax < 767.98 ? 200 : 250"
        :color="[
          { color: '#ff8f8c', percentage: 30 },
          { color: '#ffb800', percentage: 60 },
          { color: '#04cc24', percentage: 80 },
        ]"
      ></el-progress>
    </el-dialog>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import ManageCourseForm from "@/components/manageCourse/ManageCourseForm";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    ManageCourseForm,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      loading: false,
      dialogProgress: false,
      progress: 0,
      widthMax: window.innerWidth,
    };
  },
  mounted() {
    window.addEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      this.widthMax = window.innerWidth;
    },
    createCourse(data) {
      this.progress = 0;
      this.dialogProgress = true;

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();
      formData.append("name", data.courseName);

      formData.append("statusCourse", data.statusCourse);
      formData.append(
        "durationTime",
        JSON.stringify({
          open: data.courseDistanceDate[0],
          close: data.courseDistanceDate[1],
        })
      );
      formData.append(
        "totalStudyTime",
        JSON.stringify({
          hours: 0,
          minute: 0,
        })
      );

      if (typeof data.courseImageIntro.raw != "undefined") {
        formData.append("illustration", data.courseImageIntro.raw);
      }

      if (typeof data.courseVideoIntro.raw != "undefined") {
        formData.append("introduction", data.courseVideoIntro.raw);
      }

      data.courseDocuments.map((item, index) => {
        if (item.raw != null && typeof item.raw != "undefined") {
          formData.append("studyDocument", item.raw);
        }
      });

      formData.append("courseDescription", data.courseDescription);

      data.courseDescriptionFile.map((item, index) => {
        if (item.raw != null && typeof item.raw != "undefined") {
          formData.append("attachDescription", item.raw);
        }
      });

      formData.append("percent", data.coursePercentPass);
      formData.append("countPostTest", data.courseSetCount);
      formData.append("subjectNumber", data.courseSubject);

      let interval = setInterval(() => {
        if (this.progress < 80) {
          this.progress += 2;
        }
        setTimeout(() => {
          if (this.progress < 95) {
            this.progress += 1;
          }
        }, 1000);
      }, 1500);

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`course`, formData, config)
        .then((res) => {
          if (res.data.success) {
            clearInterval(interval);
            this.progress = 95;
            setTimeout(() => {
              this.progress = 100;
              setTimeout(() => {
                this.dialogProgress = false;
                this.$router.push("/manage/course/list");
              }, 500);
            }, 500);
          } else {
            this.dialogProgress = false;
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.dialogProgress = false;
          this.alertCatchError(e);
          console.log("updateMessage error", e);
        });
    },
  },
};
</script>
